<script>
    export let time_range;
    export let moving_time;
    export let layout;
    export const handles = { start, stop, move, reset };

    // --- Initial values
    const [time_begin, time_end] = $time_range;
    const initial_duration = time_end - time_begin;

    // --- Configuration
    const {
        width: w,
        zoomSpeed,
        zoomUpperBoud: upper,
        zoomLowerBoud: lower,
    } = layout;

    // --- navigation state
    let reset_flag = true;
    let scale = 1;
    let offset = 0;
    let pivot = w / 2;
    let pivot_time = computePivotTime(pivot);

    $: updateRange(scale, offset, pivot, pivot_time, reset_flag);

    function updateRange(scale, offset, pivot, pivot_time, reset_flag_) {
        if (reset_flag_) {
            reset_flag = false;
            $time_range = [time_begin, time_end];
            return;
        }
        const offset_pivot_ratio = (pivot + offset) / w;

        const new_duration = scale * initial_duration;
        const new_begin = pivot_time - new_duration * offset_pivot_ratio;
        const new_end = new_begin + new_duration;
        $time_range = [new_begin, new_end];
    }

    function computePivotTime(pivot) {
        const [current_begin, current_end] = $time_range;
        const current_duration = current_end - current_begin;
        const current_pivot_ratio = pivot / w;
        return current_duration * current_pivot_ratio + current_begin;
    }

    // --- Interface
    function start(e) {
        offset = 0;
        pivot = e.offsetX;
        pivot_time = computePivotTime(pivot);
        $moving_time = true;
    }

    function move(e) {
        if ($moving_time) {
            scale = Math.min(
                Math.max(scale - zoomSpeed * e.movementY, lower),
                upper
            );
            offset += e.movementX;
        }
    }

    function stop() {
        $moving_time = false;
    }

    function reset() {
        scale = 1;
        reset_flag = true;
    }
</script>
